import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

declare global {
  interface Window {
    config: any;
  }
}

const NSPEK_CONFIGURATION = "nSpekConfiguration";

fetch(`/config.json?v=${Date.now()}`)
  .then((response) => response.json())
  .then((config) => {
    localStorage.setItem(NSPEK_CONFIGURATION, JSON.stringify(config))
    window.config = config;
  }).catch(async (e) => {
    console.warn("Could not load configuration from server. Falling back to local storage.");
    console.warn(e);
    window.config = JSON.parse(localStorage.getItem(NSPEK_CONFIGURATION));
  }).finally(async () => {
    if (!window.config) {
      console.error("Configuration could not be found and is absolutely required.")
    }

    if (window.config.production) {
      enableProdMode();
    }

    const { AppModule } = await import('./app/app.module');

    platformBrowserDynamic().bootstrapModule(AppModule)
      .catch(err => console.error(err));
  });
